import { ToastService } from '@shared/ui';

export const copyToClipboard = (text: string, toastService: ToastService) =>
  navigator.clipboard
    .writeText(text)
    .then(() => toastService.open('Successfully copied to the clipboard'));
